<template>
    <div>
        <el-dialog :visible.sync="show" width="500px" :before-close="handleClose">
            <div class="flex titleBox" slot="title">
                <div class="flex">导入数据</div>
                <div class="flex">
                    <div class="flex">
                        导入推送：
                        <span>{{ data.success_count }}</span>
                        条
                    </div>
                    <div class="flex">
                        导入失败：
                        <span>{{ data.error_count }}</span>
                        条
                    </div>
                </div>
            </div>
            <div style="margin-bottom: 20px">失败信息</div>
            <div style="max-height: 60vh; overflow-y: auto">
                <div style="color: #333" v-for="(i, key) in data.error_messages" :key="key">{{ i }}</div>
                <!-- <el-table :data="data.failReasonList" style="width: 100%" height="30vh">
                    <el-table-column label="序号" type="index" width="100"></el-table-column>
                    <el-table-column prop="subOrderNo" label="订单编号"></el-table-column>
                    <el-table-column prop="skuNo" label="sku编码"></el-table-column>
                    <el-table-column prop="message" label="失败原因"></el-table-column>
                </el-table> -->
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <!-- <el-button type="primary" @click="downloadElsx">下载</el-button> -->
            </span>
        </el-dialog>
    </div>
</template>

<script>
import XLSX from 'xlsx';
export default {
    props: {
        show: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            default: () => {
                return {};
            }
        },
        tableData: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    methods: {
        handleClose() {
            this.$emit('show', false);
        },
        downloadElsx() {
            // console.log(this.synchronousData.failList.length, 'this.synchronousData.failList.length');
            if (!this.synchronousData.failReasonList.length) {
                this.$message.error('无可下载内容');
                return;
            }

            let list = [];
            for (let i of this.synchronousData.failReasonList) {
                list.push({
                    订单编号: i.subOrderNo,
                    sku编码: i.skuNo,
                    失败原因: i.message
                });
            }

            // 创建工作簿
            const workbook = XLSX.utils.book_new();

            // 创建工作表
            const worksheet = XLSX.utils.json_to_sheet(list);

            // 将工作表添加到工作簿
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

            // 将工作簿保存为Blob对象
            const blob = new Blob([XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });

            // 创建下载链接并触发下载操作
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = '导入订单失败列表.xlsx'; // 设置下载文件的文件名
            document.body.appendChild(link);
            link.click(); // 触发下载操作
            document.body.removeChild(link);
        }
    }
};
</script>

<style lang="scss" scoped>
.flex {
    display: flex;
    align-items: center;
}
.titleBox {
    & > div:first-child {
        margin-right: 20px;
    }

    & > div:last-child {
        font-size: 14px;
        & > div:first-child {
            & > span {
                color: green;
            }
        }

        & > div:last-child {
            margin-left: 10px;
            & > span {
                color: red;
            }
        }
    }
}
</style>